/**
 * 혈압 공통 유틸.
 *
 * 결과코드는 수동 입력(BloodPressureWrite)과 워치 동기화(useWatchBpSync) 두 곳에서 계산한다.
 * 규칙이 갈리면 같은 목록에 다른 기준으로 판정된 기록이 섞이므로 여기 하나만 둔다.
 */

/** N 정상 / C 주의 / D 위험. 높은 단계 우선. */
export const getBloodPressureResultCode = (brssrTop, brssrLwet) => {
    if (brssrTop >= 140 || brssrLwet >= 90) {
        return 'D';
    }

    if (brssrTop >= 120 || brssrLwet >= 80) {
        return 'C';
    }

    return 'N';
};

/**
 * 삼성 헬스가 주는 시각 문자열을 { recDe, recTm } 으로 쪼갠다.
 *
 * ⚠ 뒤쪽 0이 잘려서 길이가 세 가지다 — "2026-07-06T14:21", "…T14:21:13", "…T14:21:13.022".
 *   고정 패턴으로 자르면 초가 어긋나므로 조각 단위로 채운다.
 *   이미 로컬 시각이라 Date 로 되돌리지 않는다(되돌리면 타임존이 한 번 더 먹는다).
 */
export const splitLocalDateTime = (timeStr) => {
    if (!timeStr) return null;

    const [datePart, timePart = ''] = String(timeStr).split('T');
    const ymd = datePart.split('-');
    if (ymd.length !== 3) return null;

    const [hh = '00', mm = '00', rest = '00'] = timePart.split(':');
    const ss = rest.split('.')[0]; // 밀리초는 버린다. REC_TM 이 6자리다.

    const pad = (v) => String(v).padStart(2, '0');

    return {
        recDe: `${ymd[0]}${pad(ymd[1])}${pad(ymd[2])}`,
        recTm: `${pad(hh)}${pad(mm)}${pad(ss)}`,
    };
};
